export const LotteryMKTCompanyConst = [
  {
    lotteryUrl: "/image/lotteryCompany/magnum.png",
    lotteryCode: "M",
    lotteryKeyCode: "1",
  },
  {
    lotteryUrl: "/image/lotteryCompany/damacai.png",
    lotteryCode: "P",
    lotteryKeyCode: "2",
  },
  {
    lotteryUrl: "/image/lotteryCompany/toto.png",
    lotteryCode: "T",
    lotteryKeyCode: "3",
  },
  {
    lotteryUrl: "/image/lotteryCompany/singapore.png",
    lotteryCode: "S",
    lotteryKeyCode: "4",
  },
  {
    lotteryUrl: "/image/lotteryCompany/sabah88.png",
    lotteryCode: "B",
    lotteryKeyCode: "5",
  },
  {
    lotteryUrl: "/image/lotteryCompany/cashweep.png",
    lotteryCode: "W",
    lotteryKeyCode: "6",
  },
  {
    lotteryUrl: "/image/lotteryCompany/sandakan.png",
    lotteryCode: "K",
    lotteryKeyCode: "7",
  },
];

export const LotteryHLCompanyConst = [
  {
    lotteryUrl: "/image/lotteryCompany/gdlotto.png",
    lotteryCode: "H",
    lotteryKeyCode: "8",
  },
  // {
  //   lotteryUrl: "/image/lotteryCompany/nineLotto.png",
  //   lotteryCode: "N",
  //   lotteryKeyCode: "9",
  // },
];
